/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from '../models/Address';
import type { CapacityProvider } from '../models/CapacityProvider';
import type { ClaimsExperience } from '../models/ClaimsExperience';
import type { Coverage } from '../models/Coverage';
import type { CustomerType } from '../models/CustomerType';
import type { Depot } from '../models/Depot';
import type { Distributor } from '../models/Distributor';
import type { Driver } from '../models/Driver';
import type { EndorsementChange } from '../models/EndorsementChange';
import type { LargeLoss } from '../models/LargeLoss';
import type { PriceBreakdown } from '../models/PriceBreakdown';
import type { PricingMetrics } from '../models/PricingMetrics';
import type { ProductType } from '../models/ProductType';
import type { Quote } from '../models/Quote';
import type { Segment } from '../models/Segment';
import type { Translation } from '../models/Translation';
import type { UnknownVehicle } from '../models/UnknownVehicle';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class QuotesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create a Quote
   * Create a new Motor Quote
   * @returns Quote OK
   * @throws ApiError
   */
  public createQuote({
    requestBody,
  }: {
    requestBody: {
      /**
       * The unique identifer for this Quote
       */
      id: string;
      /**
       * The name of the insured or the policy holder
       */
      insuredName: string;
    },
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/motor/quotes',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        422: `Unprocessable Entity (WebDAV)`,
      },
    });
  }

  /**
   * Searching for Quotes
   * Search for Quotes by Number. The API has cursor based pagination and can be limited up to 200 results.
   * @returns any OK
   * @throws ApiError
   */
  public searchQuotes({
    term,
    after,
    status,
    businessType,
    customerId,
    limit,
  }: {
    /**
     * The search term
     */
    term?: string,
    /**
     * The previously returned cursor
     */
    after?: string,
    /**
     * The status of the quote
     */
    status?: string,
    /**
     * The business type of the quote
     */
    businessType?: string,
    /**
     * The customer to load quotes for
     */
    customerId?: string,
    /**
     * The number of results to return
     */
    limit?: number,
  }): CancelablePromise<{
    /**
     * The total number of quotes matching the criteria
     */
    total: number;
    /**
     * The cursor to return the next set of quotes
     */
    next: string | null;
    /**
     * The quotes that matched the criteria
     */
    items: Array<Quote>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/quotes',
      query: {
        'term': term,
        'after': after,
        'status': status,
        'businessType': businessType,
        'customerId': customerId,
        'limit': limit,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * Find a Quote
   * Find an existing Quote
   * @returns Quote OK
   * @throws ApiError
   */
  public findQuote({
    id,
  }: {
    /**
     * The unique identifier for the Quote
     */
    id: string,
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/quotes/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Change a Quote
   * Make changes to an existing Quote
   * @returns Quote OK
   * @throws ApiError
   */
  public changeQuote({
    id,
    requestBody,
  }: {
    /**
     * The unique identifier for the Quote
     */
    id: string,
    /**
     * A list of changes to apply to the Quote
     */
    requestBody: {
      changes: Array<({
        kind: 'set_product_type';
        data: ProductType;
      } | {
        kind: 'set_inception_time';
        data: string;
      } | {
        kind: 'set_term_length';
        data: string;
      } | {
        kind: 'set_minimum_premium_deposit';
        data: number | null;
      } | {
        kind: 'set_segment';
        data: (Segment | null);
      } | {
        kind: 'set_excess';
        data: any | null;
      } | {
        kind: 'set_coverage';
        data?: (Coverage | null);
      } | {
        kind: 'set_min_driver_age';
        data: number | null;
      } | {
        kind: 'set_max_driver_age';
        data: number | null;
      } | {
        kind: 'set_max_vehicle_value';
        data: number | null;
      } | {
        kind: 'set_expected_mileage';
        data: any | null;
      } | {
        kind: 'set_claims_experiences';
        data: Array<ClaimsExperience>;
      } | {
        kind: 'set_large_losses';
        data: Array<LargeLoss>;
      } | {
        kind: 'set_drivers';
        data: Array<Driver>;
      } | {
        kind: 'set_depots';
        data: Array<Depot>;
      } | {
        kind: 'set_notes';
        data: string;
      } | {
        kind: 'set_capacity_providers';
        data: Array<CapacityProvider>;
      } | {
        kind: 'set_distributors';
        data: Array<Distributor>;
      } | {
        kind: 'set_fee';
        data: (Translation | null);
      } | {
        kind: 'set_insured';
        data: {
          name: string;
          address?: (Address | null);
          country?: string;
        };
      } | {
        kind: 'set_vehicles';
        data: string | null;
      } | {
        kind: 'set_known_vehicles_for_pricing';
        data: string | null;
      } | {
        kind: 'set_unknown_vehicles_for_pricing';
        data: Array<UnknownVehicle>;
      } | {
        kind: 'set_vehicles_for_incepting';
        data: string | null;
      } | {
        kind: 'set_customer';
        data: string | null;
      } | {
        kind: 'set_device_subsidy';
        data: number | null;
      } | {
        kind: 'set_credit_score';
        data: number | null;
      } | {
        kind: 'set_hubspot_deal_id';
        data: string | null;
      } | {
        kind: 'set_pricing_model_version';
        data: string | null;
      } | {
        kind?: 'set_endorsements';
        data?: Array<EndorsementChange>;
      } | {
        kind: 'set_customer_type';
        data: CustomerType;
      } | {
        kind?: 'set_pricing_metrics';
        data?: PricingMetrics | null;
      } | {
        kind: 'set_managing_underwriter_id';
        data: string | null;
      })>;
    },
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/quotes/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        422: `Unprocessable Entity (WebDAV)`,
      },
    });
  }

  /**
   * Confirm a Quote Price
   * Confirms the Price of a Quote. This can either be a Price that was returned as unconfirmed from the GLM or a custom Price that was created by an Underwriter.
   * @returns Quote OK
   * @throws ApiError
   */
  public confirmQuotePrice({
    id,
    requestBody,
  }: {
    /**
     * The unique identifier for the Quote
     */
    id: string,
    /**
     * The confirmed price to associate with the Quote
     */
    requestBody: {
      breakdown: PriceBreakdown;
    },
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/quotes/{id}/confirm-price',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        422: `Unprocessable Entity (WebDAV)`,
      },
    });
  }

  /**
   * Issue a Quote
   * Issues a Quote to the Customer, also know as creating a CCQ (Contract Certain Quote). A Quote must be open and have a confirmed price in order to be issued.
   * @returns Quote OK
   * @throws ApiError
   */
  public issueQuote({
    id,
    requestBody,
  }: {
    /**
     * The unique identifier for the Quote
     */
    id: string,
    requestBody: {
      /**
       * The time the Quote was issued
       */
      time: string;
    },
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/quotes/{id}/issue',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        422: `Unprocessable Entity (WebDAV)`,
      },
    });
  }

  /**
   * Reject a Quote
   * Rejects the Quote, also know as NTU (Not Taken Up). A Quote must have been issued to the Customer to be rejected. To invalidate an open Quote you should void it.
   * @returns Quote OK
   * @throws ApiError
   */
  public rejectQuote({
    id,
    requestBody,
  }: {
    /**
     * The unique identifier for the Quote
     */
    id: string,
    requestBody: {
      /**
       * The reason the Quote was rejected
       */
      reason: string;
    },
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/quotes/{id}/reject',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        422: `Unprocessable Entity (WebDAV)`,
      },
    });
  }

  /**
   * Refer a Quote
   * @returns Quote OK
   * @throws ApiError
   */
  public referQuote({
    id,
  }: {
    /**
     * The unique identifier for the Quote
     */
    id: string,
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/quotes/{id}/refer',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        422: `Unprocessable Entity (WebDAV)`,
      },
    });
  }

  /**
   * Generate the broadcast event to generate draft documents for a Quote
   * @returns Quote OK
   * @throws ApiError
   */
  public generateDraftDocumentsQuote({
    id,
  }: {
    /**
     * The unique identifier for the Quote
     */
    id: string,
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/quotes/{id}/generate-draft-documents',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        422: `Unprocessable Entity (WebDAV)`,
      },
    });
  }

  /**
   * Void a Quote
   * Voids the Quotes. Only open and issued Quotes can be voided.
   * @returns Quote OK
   * @throws ApiError
   */
  public voidQuote({
    id,
    requestBody,
  }: {
    /**
     * The unique identifier for the Quote
     */
    id: string,
    requestBody: {
      /**
       * The reason the Quote was voided
       */
      reason: string;
    },
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/quotes/{id}/void',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        422: `Unprocessable Entity (WebDAV)`,
      },
    });
  }

  /**
   * Clone a Quote
   * Clones the Quotes
   * @returns Quote OK
   * @throws ApiError
   */
  public cloneQuote({
    id,
    requestBody,
  }: {
    /**
     * The unique identifier for the Quote
     */
    id: string,
    requestBody: {
      quoteId: string;
    },
  }): CancelablePromise<Quote> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/motor/quotes/{id}/clone',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        422: `Unprocessable Entity (WebDAV)`,
      },
    });
  }

}
